<tiime-input-container [small]="small" contentId="documentCategorySelector" [errorMessage]="errorMessage">
  <tiime-select
    id="documentCategorySelector"
    [class.selected]="documentCategoryControl.value"
    placeholder="Espace"
    [formControl]="documentCategoryControl"
    (closeOptionsPanel)="closeOptionsPanel()"
  >
    @if (documentCategoryControl.value | map: mapToSelectedDocumentCategory : selectorData; as documentCategory) {
      <app-document-category-identifier-icon
        tiimeSelectPrefix
        class="prefix-icon"
        [documentCategory]="documentCategory"
      ></app-document-category-identifier-icon>
    }
    @if (
      displayMenu &&
      (documentCategoryControl.value | map: mapToSelectedDocumentCategory : selectorData)?.owner ===
        DocumentCategoryOwner.accountant
    ) {
      <button
        tiimeSelectSuffix
        tiime-button
        color="primary"
        icon
        data-cy="document-category-menu-button"
        [matMenuTriggerFor]="documentCategoryMenu"
        (click)="$event.stopPropagation()"
      >
        <mat-icon fontSet="fontastic" fontIcon="icon-header-grey-n3-24px-more"></mat-icon>
      </button>
    }
    <input
      tiimeSelectInput
      placeholder="Rechercher un espace"
      [formControl]="searchControl"
      appFormFocusObserve
      (formChanges)="searchControlChanges()"
    />
    <div tiimeSelectOptions>
      <mat-option [value]="null">Tous les espaces</mat-option>
      @if (
        filteredSelectorData | map: mapToDocumentCategories : DocumentCategoryOwner.tiimer;
        as tiimerDocumentCategories
      ) {
        @if (tiimerDocumentCategories?.length) {
          <div class="divider sticky-30">Espaces Client</div>
        }
        @for (documentCategory of tiimerDocumentCategories; track trackById($index, documentCategory)) {
          <mat-option [value]="documentCategory.id">
            <ng-container
              [ngTemplateOutlet]="documentCategoryOption"
              [ngTemplateOutletContext]="{
                documentCategory: documentCategory
              }"
            ></ng-container>
          </mat-option>
        }
      }
      @if (
        filteredSelectorData | map: mapToDocumentCategories : DocumentCategoryOwner.accountant;
        as accountantDocumentCategories
      ) {
        @if (accountantDocumentCategories?.length) {
          <div class="divider sticky-30">Espaces Expert-comptable</div>
        }
        @for (documentCategory of accountantDocumentCategories; track trackById($index, documentCategory)) {
          <mat-option [value]="documentCategory.id">
            <ng-container
              [ngTemplateOutlet]="documentCategoryOption"
              [ngTemplateOutletContext]="{
                documentCategory: documentCategory
              }"
            ></ng-container>
          </mat-option>
        }
      }
      @if (!disableCreate) {
        <mat-option (onSelectionChange)="openCreateDocumentCategoryDialog($event)">
          <div class="create-option-content">
            <mat-icon fontSet="fontastic" fontIcon="icon-add-fontastic"></mat-icon>
            <span>Ajouter un espace Expert-comptable</span>
          </div>
        </mat-option>
      }
    </div>
  </tiime-select>
</tiime-input-container>

<mat-menu #documentCategoryMenu="matMenu" yPosition="below" xPosition="before">
  <div mat-menu-item (click)="deleteDocumentCategory()">
    <mat-icon fontSet="fontastic" fontIcon="icon-corbeille-on"></mat-icon>
    Supprimer l'espace
  </div>
</mat-menu>

<ng-template #documentCategoryOption let-documentCategory="documentCategory">
  <div class="document-category-option">
    <app-document-category-identifier-icon
      [documentCategory]="documentCategory"
    ></app-document-category-identifier-icon>
    {{ documentCategory.name }}
  </div>
</ng-template>
